import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Schedule } from './types';

type GetScheduleResponse = {
  state: number;
  value: Schedule[];
};

export const getScheduleFecha = async (): Promise<Schedule[]> => {
  try {
    const res = await apiClient.post<GetScheduleResponse>(
      Endpoints.ScheduleFecha,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
